import React from 'react';
import { Routes, Route } from 'react-router-dom';
import MainLayout from './layout/MainLayout';
import Home from './pages/Home';
import SignUp from './pages/SignUp';
import CheckYourMail from './pages/CheckYourMail';
import PasswordReset from './pages/PasswordReset';
import NewPassword from './pages/NewPassword';
import './scss/index.scss';

function App() {
  return (
    <MainLayout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/sign-up" element={<SignUp />} />
        <Route path="/check-your-mail" element={<CheckYourMail />} />
        <Route path="/password-reset" element={<PasswordReset />} />
        <Route path="/new-password" element={<NewPassword />} />
      </Routes>
    </MainLayout>
  );
}

export default App;